/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyPage } from '../models/CompanyPage';
import type { ExtendedCompanyRegistrationDto } from '../models/ExtendedCompanyRegistrationDto';
import type { FileMetadataDto } from '../models/FileMetadataDto';
import type { Pageable } from '../models/Pageable';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminCompanyRegistrationApiService {
    /**
     * Returns information about a specific company registrations identified by ID
     * @param companyRegistrationId
     * @returns ExtendedCompanyRegistrationDto OK
     * @throws ApiError
     */
    public static getCompanyRegistration(
        companyRegistrationId: string,
    ): CancelablePromise<ExtendedCompanyRegistrationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin-api/v1/company-registrations/{companyRegistrationId}',
            path: {
                'companyRegistrationId': companyRegistrationId,
            },
        });
    }
    /**
     * Updates an existing company registration
     * @param companyRegistrationId
     * @param requestBody
     * @param skipVersionCheck If true, bypasses version check and overwrites current data
     * @returns ExtendedCompanyRegistrationDto OK
     * @throws ApiError
     */
    public static updateCompanyRegistration1(
        companyRegistrationId: string,
        requestBody: ExtendedCompanyRegistrationDto,
        skipVersionCheck: boolean = false,
    ): CancelablePromise<ExtendedCompanyRegistrationDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin-api/v1/company-registrations/{companyRegistrationId}',
            path: {
                'companyRegistrationId': companyRegistrationId,
            },
            query: {
                'skipVersionCheck': skipVersionCheck,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Returns information about all available company registrations
     * @param page
     * @param registrationState
     * @param search
     * @param latestHistoryChangesAccepted
     * @param infoLetterState
     * @param legacyCompany
     * @returns CompanyPage OK
     * @throws ApiError
     */
    public static getCompanyRegistrations1(
        page: Pageable,
        registrationState?: Array<'PENDING' | 'IN_APPROVAL' | 'IN_PROGRESS' | 'CHECK_COMPANY_DATA' | 'CREATE_INVOICE' | 'UPLOAD_INVOICE' | 'ACTIVATE' | 'APPROVED' | 'REJECTED'>,
        search?: string,
        latestHistoryChangesAccepted?: boolean,
        infoLetterState?: 'REQUESTED' | 'SUPPLIED',
        legacyCompany: boolean = false,
    ): CancelablePromise<CompanyPage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin-api/v1/company-registrations',
            query: {
                'registration_state': registrationState,
                'search': search,
                'latest_history_changes_accepted': latestHistoryChangesAccepted,
                'info_letter_state': infoLetterState,
                'legacyCompany': legacyCompany,
                'page': page,
            },
        });
    }
    /**
     * Returns information about all info letters of a specified company
     * @param companyRegistrationId
     * @returns FileMetadataDto OK
     * @throws ApiError
     */
    public static getInfoLetters1(
        companyRegistrationId: string,
    ): CancelablePromise<Array<FileMetadataDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin-api/v1/company-registrations/{companyRegistrationId}/info-letters',
            path: {
                'companyRegistrationId': companyRegistrationId,
            },
        });
    }
    /**
     * Returns the file content of a info letter
     * @param companyRegistrationId
     * @param infoLetterId
     * @returns binary OK
     * @throws ApiError
     */
    public static getInfoLetterById(
        companyRegistrationId: string,
        infoLetterId: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin-api/v1/company-registrations/{companyRegistrationId}/info-letters/{infoLetterId}',
            path: {
                'companyRegistrationId': companyRegistrationId,
                'infoLetterId': infoLetterId,
            },
        });
    }
}
